import React from 'react';
import ReactDOM from 'react-dom';
import './css/main.css'
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import JankyScrollFix from './components/common/JankyScrollFix';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <JankyScrollFix />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

